import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    documents: [],
  }
}

const state = getDefaultState()

const mutations = {
  SET_DOCUMENTS(state, payload) {
    state.documents = payload
  },
}

const actions = {
  // 書類一覧をページネートした状態で取得
  async getPaginateList({ commit }, params) {
    const apiResult = await apiService.post(route('member.document.get-paginate'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 書類を取得
  async getRecord({ commit }, params) {
    const apiResult = await apiService.post(route('member.document.get-record'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  // 書類の登録
  async storeDocumentFile({ commit }, params) {
    const apiResult = await apiService.post(route('member.document.store'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 書類の削除
  async deleteDocument({ commit }, params) {
    const apiResult = await apiService.post(route('member.document.delete'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 書類のダウンロード
  async downloadDocument(_, params) {
    const apiResult = await apiService.get(route('member.document.download'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 複数の書類をダウンロード
  async downloadDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.document.download_documents'), params)
    if (apiResult) {
      return apiResult
    }
  },

  // 登録済みプロジェクトの全書類を出力
  async downloadRegisteredProjectDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.document.download-registered-project-documents'), params, {
      responseType: 'blob',
      headers: {
        Accept: 'application/zip',
      },
    })
    if (apiResult) {
      return apiResult
    }
  },

  async downloadDataImportStatus({ commit }, params) {
    const apiResult = await apiService.post(route('member.document.download-data-import-status'), params)
    if (apiResult) {
      return apiResult
    }
  },

  async deleteDataImportStatus({ commit }, params) {
    const apiResult = await apiService.post(route('member.document.delete-data-import-status'), params)
    if (apiResult) {
      return apiResult
    }
  },

  async downloadDataImportStatuses({ commit }, params) {
    const apiResult = await apiService.post(route('member.document.download-data-import-statuses'), params)
    if (apiResult) {
      return apiResult
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
